/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, February 23, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var par = require("par");
var dotty = require("dotty");

var FormFileUtils = require("../../utils/FormFileUtil");

const {
	formatFile,
	findFiles,
} = FormFileUtils;

module.exports = Model({
	name: "activeownformsubmission",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,
	_submissions: [],
	_submissionId: null,
	_formId: null,

	recalculate: recalculate,
	handle_submission_delete_cancel: handle_submission_delete_cancel,
	handle_submission_lock_cancel: handle_submission_lock_cancel,
	uploadFiles: uploadFiles
});

function init() {
	this._submissions = [];
	this._submissionId = null;
	this._formId = null;
	this._form = null;
	this.push(false);
}

function uninit() {
	this._submissions = [];
	this._submissionId = null;
	this._formId = null;
	this._form = null;
}


function listeners() {
	return {
		"ownformsubmissions:updated": handle_own_submission_update,
		"ownformsubmissions:cleared": handle_submissions_clear,
		"ownformlist:updated": handle_forms_update
	};
}

function triggers() {
	return {
		"view": handle_view,
		"update:start": handle_updating,
		"update:submit": handle_update_submit,
		"delete:start": handle_submission_delete_start,
		"delete:confirm": handle_submission_delete_confirm,
		"delete:cancel": handle_submission_delete_cancel,
		"creating": handle_submission_creating,
		"submit": handle_submission_submit,
		"cancel": handle_cancel,
		"lock:start": handle_submission_lock_start,
		"lock:confirm": handle_submission_lock_confirm,
		"lock:cancel": handle_submission_lock_cancel,
	};
}


function handle_cancel() {
	this.dispatch("cancelled");

	this.emit("usermetrics:trigger:track", "cancel own form submission", {
		"submission id": this._submissionId
	});
}

function recalculate(){
	var submissionId = this._submissionId;
	var submissions =  this._submissions;
	var formDefinitions = this._formDefinitions || {};

	if(!submissionId) return;

	// Use array.find to get the submission data
	var submissionData = submissions.find(function(submission) {
		return submission._id === submissionId;
	});

	this._form = (formDefinitions[(submissionData || {}).schema] || {}).schema;
	this.push(submissionData);

}

function handle_own_submission_update(submissions){
	this._submissions = submissions.submissions;
	var submissionId = this._submissionId;

	if(!submissions || !submissionId || !submissions.form) return;

	var stillExists = submissions.submissions.some(function(submission){
		return submission._id === submissionId;
	});

	if(!stillExists){
		this._submissionId = null;
		this.push(false);
	} else {
		this.recalculate();
	}
}

function handle_view(data) {
	this._submissionId = data.id;
	this.recalculate();
	this.dispatch("viewing");
	// Use this.dispatch("viewing") to make desktop change the page
	this.emit("usermetrics:trigger:track", "view own form submission", {
		"submission id": data.id
	});
}

function handle_updating(data) {
	this._submissionId = data.id;
	this.recalculate();
	this.dispatch("updating");
	// Use this.dispatch("viewing") to make desktop change the page
	this.emit("usermetrics:trigger:track", "begin updating own form submission", {
		"submission id": data.id
	});
}

function handle_update_submit(data) {
	var submissionId = this._submissionId;
	var form = this._form || {};
	var formProperties = form.properties;

	var files = findFiles(formProperties, data);
	var api = this.api.forms.submission.group.own.update;

	this.emit("save:trigger:start");
	this.extend({
		data: data,
	});
	this.emit("usermetrics:trigger:track", "update own form submission", {
		"submission id": submissionId
	});
	return this.uploadFiles(files, data)
		.then(par(api, submissionId))
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this));
}

function handle_update_success() {
	var message = "groupform.updateSuccess"; // todo
	this.emit("toast:trigger:show", {
		content: message
	});
	this.emit("save:trigger:finish");
	this.dispatch("finished");
	this.dispatch("viewed", {
		section: "groupforms_" + this._submissions[0].schema,
		timestamp: new Date().toISOString(),
	});
}

function handle_update_error() {
	this.emit("save:trigger:finish");
	var message = "groupform.updateError"; // todo
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
	this.dispatch("finished");
}

function handle_submission_delete_start() {
	this.extend({
		deleting: true
	});

	this.emit("usermetrics:trigger:track", "begin deleting own form submission", {
		"submission id": this._submissionId
	});
}

function handle_submission_delete_cancel() {
	this.extend({
		deleting: false
	});

	this.emit("usermetrics:trigger:track", "cancel deleting own form submission", {
		"submission id": this._submissionId
	});
}

function handle_submission_delete_confirm() {
	var submissionId = this._submissionId;
	this.emit("save:trigger:start");
	this.api.forms.submission.group.own.delete(submissionId)
		.then(handle_delete_success.bind(this))
		.catch(handle_delete_error.bind(this));
	this.handle_submission_delete_cancel();

	this.emit("usermetrics:trigger:track", "delete own form submission", {
		"submission id": submissionId
	});
}

function handle_delete_success() {
	this._submissionId = null;
	var message = "groupform.delete"; // todo
	this.emit("toast:trigger:show", {
		content: message
	});
	this.emit("save:trigger:finish");
	this.dispatch("finished");
	this.dispatch("viewed", {
		section: "groupforms_" + this._submissions[0].schema,
		timestamp: new Date().toISOString(),
	});
}

function handle_delete_error() {
	this.emit("save:trigger:finish");
	var message = "groupform.deleteError"; // todo
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
	this.dispatch("finished");
}

function handle_submission_creating(data) {
	var formId = data.id;
	var formDefinitions = this._formDefinitions || {};
	if (!formId) return;
	this._formId = formId;
	this._form = (formDefinitions[formId] || {}).schema;
	this.dispatch("creating", formId);
	if(data.mode !== "silence") {
		this.emit("usermetrics:trigger:track", "begin creating own form submission", {
			"form id": formId
		});
	}
}

function handle_submission_submit(data) {
	var formId = this._formId;
	var form = this._form || {};
	var formProperties = form.properties;

	if (!formId) return;

	var files = findFiles(formProperties, data);
	var api = this.api.forms.submission.group.own.create;

	this.emit("save:trigger:start");

	this.emit("usermetrics:trigger:track", "create own form submission", {
		"form id": formId
	});
	return this.uploadFiles(files, data)
		.then(par(api, formId))
		.then(finish_load.bind(this))
		.catch(handle_create_failed.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
	var message = "groupform.submit"; // todo
	this.emit("toast:trigger:show", {
		content: message
	});
	this.recalculate();
	this.dispatch("finished");
	this.dispatch("viewed", {
		who: this._who,
		section: "groupforms_" + this._formId,
		timestamp: new Date().toISOString(),
	});
}

function handle_submission_lock_start() {
	this.extend({
		locking: true
	});

	this.emit("usermetrics:trigger:track", "begin locking own form submission", {
		"submission id": this._submissionId
	});
}
function handle_submission_lock_cancel() {
	this.extend({
		locking: false
	});

	this.emit("usermetrics:trigger:track", "cancel locking own form submission", {
		"submission id": this._submissionId
	});
}

function handle_submission_lock_confirm() {
	var submissionId = this._submissionId;
	this.emit("save:trigger:start");
	this.api.forms.submission.group.own.lock(submissionId)
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this));
	this.handle_submission_lock_cancel();

	this.emit("usermetrics:trigger:track", "lock own form submission", {
		"submission id": submissionId
	});
}

function handle_submissions_clear(){
	this._submissions = [];
	this._submissionId = null;
	this._formId = null;
	this.push(null);
}

function handle_create_failed() {
	this.emit("save:trigger:finish");
	var message = "groupform.updateError";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function handle_forms_update(data){
	this._formDefinitions = data;
}

async function uploadFile(data) {
	const file = data.data;
	try {
		const uploaded = await this.api.forms.submission.group.own.file(file);
		return {
			key: data.key,
			file: uploaded
		};
	} catch (error) {
		if (error?.response?.message === "No file provided") return;
		throw error;
	}
}

async function uploadFiles(files, data) {
	if (!files.length) return data;
	const uploaded = await Promise.all(files.map(uploadFile.bind(this)));
	uploaded.forEach(upload => {
		if (!upload) return;
		dotty.put(data, upload.key, formatFile(upload.file));
	});
	return data;
}